export interface SendMessage {
  returnCode: string;
  topic: string;
  [key: string]: unknown;
}

export function isSendMessage(message: unknown): message is SendMessage {
  if (typeof message !== 'object' || message === null) {
    return false;
  }
  const candidate = message as Record<string, unknown>;
  return (
    typeof candidate['returnCode'] === 'string' &&
    candidate['returnCode'].trim().length > 0 &&
    typeof candidate['topic'] === 'string' &&
    candidate['topic'].trim().length > 0
  );
}
